
  // cart item increase 
  function cartItemChange(e, el) {
    var id = $(el).data('id');
    var qty = $(el).val();
    $.ajax({
        type : "POST",
        url:'/cart/change.js',
        data: {
            id: parseFloat(id),
            quantity: qty
        },
        dataType:'json',
        success:function(data) {
            cart_item_update();
            // console.log('Increased');
        },
        error:function(err) {
            console.log('Error')
        }
    })
  }
  
  // cart item decrease
  function cartItemRemoved(e, el) {
    var id = $(el).data('id');
    $.ajax({
        type : "POST",
        url:'/cart/change.js',
        data: {
            id: parseFloat(id),
            quantity: 0
        },
        dataType:'json',
        success:function(data) {
            cart_item_update();
        },
        error:function(err) {
            console.log('Error')
        }
    })
  }
  
  
//   // cart item update 
//   function cart_item_update() {
//     fetch('/?section_id=cart-items')
//         .then(reponse => reponse.text())
//         .then(cartData => {
//             var cart_html = $(cartData);
//             // var cart_empty = $('.cart-empty', cart_html);
//             var cart_items = $('.parent_container', cart_html);
//             // var cart_summery = $('.summery_container', cart_html);
//             // $('.cart-empty').replaceWith(cart_empty);
//             $('.parent_container').replaceWith(cart_items);
//             // $('.summery_container').replaceWith(cart_summery);
//     });
  
//     $.getJSON('/cart.js', function(cart){
//         var total_items = cart.item_count;
//         $('.cart_count').text(total_items);
//     })
//   }

// Function to remove main product and its linked extra products
function removeMainAndExtras(mainProductId) {
    $.getJSON('/cart.js', function(cart) {
        var lineItemIdsToRemove = [];

        // Loop through all cart items
        cart.items.forEach(function(item) {
            if (item.properties && item.properties.main_product_id === mainProductId) {
                lineItemIdsToRemove.push(item.id);  // Mark items with the same main_product_id for removal
            }
        });

        // Remove the main product
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                line: cart.items.find(item => item.properties && item.properties.main_product_id === mainProductId).id,
                quantity: 0
            },
            dataType: 'json',
            success: function() {
                // After removing the main product, remove related extra products
                lineItemIdsToRemove.forEach(function(lineItemId) {
                    $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: {
                            line: lineItemId,
                            quantity: 0
                        },
                        dataType: 'json',
                        success: function(response) {
                            console.log('Extra product removed');
                        },
                        error: function(err) {
                            console.error('Error removing extra product:', err);
                        }
                    });
                });
                cart_item_update();  // Update the cart view
            },
            error: function(err) {
                console.error('Error removing main product:', err);
            }
        });
    });
}


